import htmlDecode from './htmlDecode';
import htmlEncode from './htmlEncode';

import axios from 'axios';

/**
     * Permite realizar solicitudes al servidor utilizando protocolo SOAP.
     * @param {String} action - Método al cual se realiza la solicitud.
     * @param {Int} timeout - Tiempo de espera a respuesta.
     * @param {String} message - Mensaje con datos para realizar la solicitud.
     * @returns {Object} Respuesta de la solicitud con estructura XML.
    */
async function soapRequestFunction(action, timeout, message) {
  //const soapRequest = require('easy-soap-request');
  var XMLParser = require('react-xml-parser');
  var xmlResponse = null;
  const localBaseUrl = 'http://localhost:8080';
  const developBaseUrl = 'http://desarrollo.grapesoft.cl:8082';
  const productionBaseUrl = 'http://class.grapesoft.cl:8081';
  const productionBaseUrlSSL = 'https://api.estadisticas.class.grapesoft.cl';
  const messageEncoded = htmlEncode(message);
  //console.log("soap: ", action);
  //console.log("mensaje request: ", message);
  const baseUrl= productionBaseUrlSSL;
  const url = baseUrl+'/classWAR/services/WSStatistics';
  const sampleHeaders = {
    'user-agent': 'sampleTest',
    'Content-Type': 'text/xml;charset=UTF-8',
    'soapAction': baseUrl+'/classWAR/wsdl/WSStatistics.wsdl#' + action,
  };
  const xml = `<?xml version="1.0" encoding="UTF-8"?><SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns1="`+baseUrl+`/interfaz/wsdl/WSStatistics.wsdl">
      <SOAP-ENV:Body><ns1:`+ action + `><ns1:xml>` + messageEncoded + `</ns1:xml></ns1:` + action + `></SOAP-ENV:Body>
    </SOAP-ENV:Envelope>`;
/*
  const { response } = await soapRequest({ url: url, headers: sampleHeaders, xml: xml, timeout: { timeout } }); 
  const { headers, body, statusCode } = response;
  var xmlBody = new XMLParser().parseFromString(body);
  const responseEncoded = xmlBody.getElementsByTagName(action+'Response')[0].children[0].value;
  const responseDecoded = htmlDecode(responseEncoded);
  console.log("mensaje response: ", responseDecoded);
  xmlResponse = new XMLParser().parseFromString(responseDecoded);
  return xmlResponse;
*/
  const response = await axios.post(url, xml, {headers: sampleHeaders});
  const { data } = response; 

  //console.log(data);
  var xmlBody = new XMLParser().parseFromString(data);
  //console.log(xmlBody);
  const responseEncoded = xmlBody.getElementsByTagName(action+'Response')[0].children[0].value;
  const responseDecoded = htmlDecode(responseEncoded);
  //console.log("resieved mensaje: ", responseDecoded);
  xmlResponse = new XMLParser().parseFromString(responseDecoded);
  return xmlResponse;
}

export default soapRequestFunction;